export var Role;
(function (Role) {
    Role["inventory"] = "magazijn";
    Role["organisation"] = "organisatie";
    Role["dataManagementSystem"] = "obs";
    Role["assetData"] = "asset data";
})(Role || (Role = {}));
